module.exports = __webpack_public_path__ + "0-es2015.8322ece4c188ac162179.worker.js"